import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export const DialogueContext = React.createContext();

export const ActionsMenu = ({ children }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <DialogueContext.Provider
      value={{
        menuOpen: open,
        handleMenuClick: handleClick,
        handleMenuClose: handleClose
      }}
    >
      <Button
        id="user-actions-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="contained"
        color="primary"
        label="Actions"
        //startIcon={<EditIcon />}
        sx={{ textTransform: 'none' }}
      >
        Actions
      </Button>
      <Menu
        id="user-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'user-actions-button'
        }}
      >
        {children}
      </Menu>
    </DialogueContext.Provider>
  );
};

export const ActionsMenuItem = ({ children, record, onClick }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    console.log('HANDLEOPEN CALLED');
    if (onClick) {
      onClick(record); // Call the passed in onClick handler (for redirects etc.)
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    console.log('HANDLECLOSE CALLED');
    setOpen(false);
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...child.props,
        openDialog: open,
        handleDialogClose: handleClose
      });
    }
    return child;
  });

  return <MenuItem onClick={handleOpen}>{childrenWithProps}</MenuItem>;
};
